module.exports = __webpack_public_path__ + "img/atletic-club-d'escaldes-logo-icon.bed28ac4.png";